import { getCurrentInstance } from '@vue/composition-api';
import Vue from 'vue';

export function useInstance() {
  const instance = getCurrentInstance();
  const vm = instance?.proxy || instance || new Vue({});

  return vm as any;
}
